import { Chat } from "@acoladgroup/tempo-messaging-library";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import Badge from "components/Badge";
import { useTranslation } from "react-i18next";

interface TempoChatHeaderProps {
  chatData: Chat;
}

export default function TempoChatHeader({ chatData }: TempoChatHeaderProps) {
  const { t } = useTranslation();

  return (
    <div data-testid="tempo-messaging-chat-header" className="px-4 py-2">
      <div className="flex items-center gap-2 text-lg font-bold dark:text-gray-300">
        <span data-testid="tempo-messaging-chat-header-title">{chatData.customerName}</span>
        <Badge color="sky">{t("messaging.chatHeader.customer")}</Badge>
        {chatData.closed && (
          <span
            data-testid="tempo-messaging-chat-closed-badge"
            className="inline-flex items-center gap-1 rounded-full border border-gray-300 bg-gray-300 px-2 py-1 text-xs font-medium text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
            title={t("messaging.chatClosed.label")}
          >
            <LockClosedIcon className="size-4" /> {t("messaging.chatClosed.closed")}
          </span>
        )}
      </div>
      <div
        data-testid="tempo-messaging-chat-details"
        className="text-color-secondary mb-2 border-b border-gray-300 pb-2 text-sm dark:text-gray-300"
      >
        <div data-testid="tempo-messaging-chat-project">
          <span>{t("messaging.chatHeader.project")}</span>
          <span className="font-medium">{chatData.projectName}</span>
        </div>
        <div data-testid="tempo-messaging-chat-task">
          <span>{t("messaging.chatHeader.task")}</span>
          <span className="font-medium">{chatData.taskCode}</span>
        </div>
        <div data-testid="tempo-messaging-chat-languages">
          <span>{t("messaging.chatHeader.languages")}</span>
          <span className="font-medium">
            {chatData.sourceLanguage} → {chatData.targetLanguage}
          </span>
        </div>
        <div data-testid="tempo-messaging-chat-communication-language">
          <span>{t("messaging.chatHeader.customerCommunicationLanguage")}</span>
          <span className="font-medium">{chatData.customerCommunicationLanguage}</span>
        </div>
      </div>
    </div>
  );
}
